<template>
  <h1>contact requests</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>